import * as swcHelpers from '@swc/helpers';
import { unwrapResponse } from '../response.js';
import { acceptJson, postJson } from '../shared.js';

const getProductById = function() {
    var _ref = swcHelpers.asyncToGenerator(function*(apiUrl, request) {
        const expand = request.expand ? request.expand.join('|') : null;
        return unwrapResponse((yield fetch(`${apiUrl}/${request.productId}?expand=${expand}`, {
            method: 'GET',
            headers: swcHelpers.objectSpread({}, acceptJson, postJson)
        })));
    });
    return function getProductById(apiUrl, request) {
        return _ref.apply(this, arguments);
    };
}();
const getProductBySlug = function() {
    var _ref = swcHelpers.asyncToGenerator(function*(apiUrl, request) {
        const expands = request.expand || [
            'attributes',
            'tax-category',
            'discounts',
            'categories',
            'product-type',
            'review-enabled', 
        ];
        return unwrapResponse((yield fetch(`${apiUrl}/slug/${request.slug}?expand=${expands.join('|')}`, {
            method: 'GET',
            headers: swcHelpers.objectSpread({}, acceptJson, postJson)
        })));
    });
    return function getProductBySlug(apiUrl, request) {
        return _ref.apply(this, arguments);
    };
}();

export { getProductById, getProductBySlug };
//# sourceMappingURL=product.js.map
